import Vue from "vue";
import axios from "axios";

// Mise en place d'axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
Vue.prototype.$http = axios;

export default{
itemLang:"lang00",
token:null,
data:{},
async getData(){
  try {
    const reponse = await axios
    .create({
      baseURL: process.env.VUE_APP_BASE_API_URL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        token: this.token,
      },
    })
    .get("resultatbac/get");
    
    if(reponse && reponse.status === 200){
      return reponse.data;
    }
    else{
      return "error";
    }
  } catch (error) {
    console.log(error);
    return "error";
  }
},
postData(){
  return axios
  .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept : "application/json",
          token : this.token,
        },
      })
      .post("resultatbac/post", this.data);
},
}